import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions, type Permissions } from '../../hooks/usePermissions';

type PermissionKey = {
  [K in keyof Permissions]: Permissions[K] extends boolean ? K : never;
}[keyof Permissions];

interface RoleProtectedRouteProps {
  requiredPermission: PermissionKey;
  fallbackRoute?: string;
  children: ReactNode;
}

const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  requiredPermission,
  fallbackRoute = '/dashboard',
  children,
}) => {
  const permissions = usePermissions();

  if (!permissions[requiredPermission]) {
    return <Navigate to={fallbackRoute} replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
